<mat-nav-list>
    <div class="nav-header">
      <img class="nav-logo" [src]="environmentConfig.logoSrc" alt="{{environmentConfig.imageAlt}}" />
      <!-- <button mat-icon-button>
      <mat-icon (click)='onToggleSideBar()' class="menu-icon">menu</mat-icon>
    </button> -->
  </div>

  <div class="user-about nav-text">
    <h3>
      {{ userName | slice : 0 : 20
      }}<span *ngIf="userName?.length > 20">...</span>
    </h3>
    <!-- <h5>{{ userMail }}</h5> -->
  </div>

  <div class="inner-background">
    <img
      class="nav-avatar"
      *ngIf="!userAvatar"
      src="assets/images/avatar.png"
      alt="avatar"
    />
    <img
      class="nav-avatar"
      *ngIf="userAvatar"
      [src]="userAvatar"
      alt="avatar"
    />

    <mat-accordion>
      <ng-container>
        <div *ngFor="let navItem of navItems">
          <mat-expansion-panel
            *ngIf="navItem.children.length && navItem.is_permitted"
            class="mat-elevation-z0"
          >
            <mat-expansion-panel-header class="side-expand">
              <mat-panel-title class="nav-text">
                <mat-icon
                  class="icon margin"
                  aria-hidden="false"
                  aria-label="Profile"
                  >{{ navItem.icon }}</mat-icon
                >
                {{ navItem.title }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let subMenuItem of navItem.children">
              <a
                mat-list-item
                [routerLink]="subMenuItem.uri"
                routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="nav-text"
                *ngIf="subMenuItem.is_permitted"
                >{{ subMenuItem.value }}</a
              >
            </div>
          </mat-expansion-panel>

          <a
            *ngIf="
              !navItem.children.length && navItem.new && navItem.is_permitted
            "
            mat-list-item
            class="single-item"
            href="{{ navItem.uri }}"
            target="_blank"
          >
            <mat-panel-title class="nav-text">
              <mat-icon aria-hidden="false" aria-label="Setting">{{
                navItem.icon
              }}</mat-icon>
              <span>
                {{ navItem.title }}
              </span>
            </mat-panel-title>
          </a>
          <a
            *ngIf="
              !navItem.children.length && !navItem.new && navItem.is_permitted
            "
            mat-list-item
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="single-item"
            [routerLink]="navItem.uri"
          >
            <mat-panel-title class="nav-text">
              <mat-icon aria-hidden="false" aria-label="Setting">{{
                navItem.icon
              }}</mat-icon>
              <span>
                {{ navItem.title }}
              </span>
            </mat-panel-title>
          </a>
        </div>
      </ng-container>
    </mat-accordion>
  </div>
</mat-nav-list>

<ng-template #documentAlertModal>
  <div class="dialog-wrapper">
    <div class="close-icon">
      <a (click)="closeDialogs()">X</a>
    </div>
    <h1 class="red-text">IMPORTANT NOTICE!</h1>
    <p>
      Dear <b>{{ userName }}</b
      >,
    </p>
    <p>
      At {{environmentConfig.title}} security and privacy of your account is important for us. By
      enabling Two-Factor Authentication(2FA), you can increase your account
      security and reduce risk.
    </p>
    <p class="red-text">
      <b>What is 2FA?</b>
    </p>
    <p>
      <b>Two-factor authentication (2FA)</b> is an identity and access
      management security method that requires two forms of identification to
      access resources and data. 2FA gives cutomers the ability to monitor and
      help safeguard their account.
    </p>
    <p class="red-text">
      <b>How do I activate 2FA?</b>
    </p>
    <p>
      Please go to setting tab on left menu bar.(<a
        routerLink="/dashboard/settings"
        (click)="closeDialogs()"
        >"Settings"</a
      >) Under security tab, you can enable mobile phone verification and double
      authentication apps in order to safeguard your account.
    </p>
    <p>Stay Safe,</p>
    <p>{{environmentConfig.title}} Team</p>
  </div>
</ng-template>
